module.exports = __webpack_public_path__ + "img/Icon simple-google.efbeb34d.svg";